import { Box, Grid, styled, Typography } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
import { Footer } from "../../components/Footer/Footer";
import HeaderGeneral from "../../components/Header/HeaderGeneral";
import { PolicyNavGrid } from "./Components/PolicyNavGrid";

const NavGrid = styled(Grid)({
  height: "100%",
});

const ItemGrid = styled(Grid)({
  padding: "5%",
});

const BaseGrid = styled(Grid)({
  height: "100%",
  minHeight: "90vh",
});

const TitleText = styled(Typography)({
  paddingBottom: "2%",
});

export interface IPrivacyPolicyPageProps {}

export function PrivacyPolicyPage(props: IPrivacyPolicyPageProps) {
  return (
    <Box>
      <HeaderGeneral />
      <BaseGrid container direction="row">
        <NavGrid container item sm={12} md={3}>
          <PolicyNavGrid />
        </NavGrid>
        <Grid container item sm={12} md={9}>
          <ItemGrid>
            <TitleText variant="h3">Privacy Policy</TitleText>
            <br />
            
            <Typography variant="h4">1. Pendahuluan</Typography>
            <br />
            <Typography>
              Kebijakan Privasi ini menjelaskan kebijakan dan prosedur PT Indomobil Sukses Internasional Tbk, termasuk anak-anak perusahaan dan afiliasinya (selanjutnya disebut "IMSI" atau "Kami") dalam melakukan pengumpulan, penyimpanan, penggunaan, dan penggunaan informasi Anda saat Anda menggunakan Aplikasi/Situs Web/Platform (“Layanan”) Kami, dimana Kami menjaga privasi Anda dengan serius dan akan memproses Data Pribadi Anda sesuai dengan peraturan perundang-undangan yang berlaku. Layanan Kami termasuk namun tidak terbatas pada Layanan yang dikembangkan oleh Kami yang telah Anda akses atau unduh di perangkat elektronik Anda, dengan tujuan untuk memberikan akses informasi, materi pembelajaran, dan layanan yang paling relevan dan berguna bagi Anda.
            </Typography>
            <br />
            <Typography>
              Untuk sepenuhnya memahami hak-hak Anda, mohon agar Anda membaca Kebijakan Privasi ini untuk dapat mengetahui dan memahami bagaimana Kami melakukan pemrosesan Data Pribadi Anda. Kebijakan Privasi ini bersifat melengkapi tetapi tidak menghapus atau menggantikan setiap persetujuan lain yang mungkin telah Anda berikan sebelumnya kepada Kami sehubungan dengan Data Pribadi Anda. Persetujuan yang diberikan di sini merupakan tambahan untuk setiap hak yang mungkin dimiliki oleh Kami berdasarkan hukum yang berlaku untuk melakukan pemrosesan Data Pribadi Anda.
            </Typography>
            <br />

            <Typography variant="h4">2. Tujuan Kebijakan Privasi</Typography>
            <br />
            <Typography>
              Kebijakan Privasi ini bertujuan untuk menjelaskan bahwa Data Pribadi Anda dapat digunakan dalam rangka penyediaan dan pengelolaan Layanan Kami, komunikasi dan penyampaian pembaruan, verifikasi dokumen, peningkatan mutu layanan, pelaksanaan riset pasar dan analisis, pencegahan penipuan dan tindak kejahatan, pemenuhan kewajiban hukum, penanganan klaim atau proses hukum, serta kegiatan pemasaran, promosi, dan tujuan lain yang secara wajar berkaitan dengan hal-hal tersebut. Penjelasan lebih rinci mengenai hal ini dapat Anda temukan pada bagian Tujuan Pengolahan Data Pribadi di bawah ini.
            </Typography>
            <br />

            <Typography variant="h4">3. Ruang Lingkup Pengelolaan Data Pribadi</Typography>
            <br />
            <Typography>
              Kebijakan Privasi ini menjelaskan perihal Data Pribadi Anda yang Kami kumpulkan, menetapkan informasi penting mengenai pengumpulan, penggunaan, pemrosesan, pengungkapan dan penyimpanan Data Pribadi Anda, bagaimana dan kapan kami dapat menggunakan Data Pribadi Anda, bagaimana kami melindungi Data Pribadi Anda, siapa yang memiliki akses ke Data Pribadi Anda, dan kemampuan Anda untuk mengakses dan memperbaikinya.
            </Typography>
            <br />

            <Typography variant="h4">4. Dasar Hukum</Typography>
            <br />
            <Typography>
              Data Pribadi Anda akan diproses berdasarkan dasar hukum terkait informasi elektronik dan Pelindungan Data Pribadi sebagai berikut:
            </Typography>
            <br />
            <ul>
              <li>
                <Typography>a. Undang-Undang Republik Indonesia Nomor 11 Tahun 2008 tentang Informatika dan Transaksi Elektronik;</Typography>
              </li>
              <li>
                <Typography>b. Undang-Undang Republik Indonesia No. 19 Tahun 2016 tentang Perubahan atas Undang-Undang Republik Indonesia No. 11 Tahun 2008 tentang Informatika dan Transaksi Elektronik;</Typography>
              </li>
              <li>
                <Typography>c. Undang-Undang Republik Indonesia No. 1 Tahun 2024 tentang Perubahan Kedua atas Undang-Undang Republik Indonesia No. 11 Tahun 2008 tentang Informatika dan Transaksi Elektronik;</Typography>
              </li>
              <li>
                <Typography>d. Peraturan Menteri Komunikasi dan Informatika Republik Indonesia No. 5 Tahun 2020 tentang Penyelenggara Sistem Elektronik Lingkup Swasta;</Typography>
              </li>
              <li>
                <Typography>e. Peraturan Menteri Komunikasi dan Informatika Republik Indonesia No. 10 Tahun 2021 tentang Perubahan atas Peraturan Menteri Komunikasi dan Informatika Republik Indonesia No. 5 Tahun 2020 tentang Penyelenggara Sistem Elektronik Lingkup Swasta;</Typography>
              </li>
              <li>
                <Typography>f. Peraturan Menteri Komunikasi dan Informatika Republik Indonesia No. 20 Tahun 2016 tentang Pelindungan Data Pribadi dalam Sistem Elektronik;</Typography>
              </li>
              <li>
                <Typography>g. Undang-Undang Republik Indonesia No. 27 Tahun 2022 tentang Pelindungan Data Pribadi (“UU PDP”); dan</Typography>
              </li>
              <li>
                <Typography>h. Peraturan terkait lainnya.</Typography>
              </li>
            </ul>
            <br />

            <Typography variant="h4">5. Definisi</Typography>
            <br />
            <ul>
              <li>
                <Typography>a. Data Pribadi adalah setiap informasi tentang seseorang yang dapat mengidentifikasi orang tersebut, baik langsung maupun tidak langsung.</Typography>
              </li>
              <li>
                <Typography>b. Subjek Data Pribadi adalah orang perseorangan yang datanya diproses dan memiliki hak-hak yang dijamin undang-undang, seperti hak untuk mengakses, memperbarui, menghapus, atau menarik persetujuan atas pemrosesan data.</Typography>
              </li>
              <li>
                <Typography>c. Pengendali Data Pribadi (Data Controller) adalah pihak yang menentukan tujuan dan kendali atas pemrosesan Data Pribadi serta bertanggung jawab memastikan keamanan, keakuratan, dan transparansi pengelolaan data.</Typography>
              </li>
              <li>
                <Typography>d. Prosesor Data Pribadi (Data Processor) adalah pihak yang memproses Data Pribadi atas nama pengendali dan wajib tunduk pada instruksi serta menjaga kerahasiaan dan keamanan data.</Typography>
              </li>
            </ul>
            <br />

            <Typography variant="h4">6. Jenis Data Pribadi yang Dikumpulkan</Typography>
            <br />
            <Typography>
              Kami dapat mengumpulkan atau meminta Anda untuk memberikan informasi Data Pribadi tertentu yang dapat digunakan untuk menghubungi atau mengidentifikasi Anda ketika Anda memilih dan menggunakan Layanan yang telah kami sediakan. Data Pribadi yang dapat diidentifikasi dan diproses dapat mencakup Data Pribadi Umum dan Data Pribadi Spesifik, namun tidak terbatas pada:
            </Typography>
            <br />
            <ul>
              <li><Typography>a. Nama;</Typography></li>
              <li><Typography>b. Alamat;</Typography></li>
              <li><Typography>c. Tempat dan Tanggal lahir;</Typography></li>
              <li><Typography>d. Jenis kelamin;</Typography></li>
              <li><Typography>e. Profesi atau pekerjaan;</Typography></li>
              <li><Typography>f. Alamat surat elektronik (E-mail);</Typography></li>
              <li><Typography>g. Riwayat atau Status pendidikan;</Typography></li>
              <li><Typography>h. Status pernikahan;</Typography></li>
              <li><Typography>i. Nomor Telepon;</Typography></li>
              <li><Typography>j. Jumlah anggota keluarga; dan</Typography></li>
              <li><Typography>k. Informasi lain yang akan ditentukan oleh Kami.</Typography></li>
            </ul>
            <br />
            <Typography>
              Data lain mungkin telah dikumpulkan secara otomatis saat menggunakan Layanan Kami. Data lain dapat mencakup informasi seperti alamat protokol internet perangkat Anda (misalnya, alamat IP), jenis browser, versi browser, halaman layanan kami yang Anda kunjungi, waktu dan tanggal kunjungan Anda, waktu yang dihabiskan di halaman tersebut, pengidentifikasi perangkat unik, dan data diagnostik lainnya (Cookie).
            </Typography>
            <br />
            <Typography>
              Ketika Anda mengakses Layanan dengan atau melalui perangkat seluler, kami dapat mengumpulkan informasi tertentu secara otomatis, termasuk, namun tidak terbatas pada, jenis perangkat seluler yang Anda gunakan, ID unik perangkat seluler Anda, alamat IP perangkat seluler Anda, sistem operasi perangkat seluler Anda, jenis browser Internet seluler yang Anda gunakan, pengidentifikasi perangkat unik, dan data diagnostik lainnya (Cookie).
            </Typography>
            <br />
            <Typography>
              Kami juga dapat mengumpulkan informasi yang dikirimkan browser Anda setiap kali Anda mengunjungi Layanan kami atau mengakses layanan dengan atau melalui perangkat seluler. Cookie memungkinkan kami untuk melacak dan mengumpulkan data perilaku pengguna sehingga kami dapat menargetkan minat pengguna kami dengan lebih baik dan meningkatkan pengalaman mereka di Situs.
            </Typography>
            <br />
            <Typography>
              Anda dapat mengatur browser Anda untuk menolak semua cookie atau untuk menunjukkan kapan cookie sedang dikirim. Namun, beberapa fitur atau Layanan mungkin tidak berfungsi dengan baik tanpa cookie mengingat beberapa halaman web, pesan e-mail, dan/atau buletin kami mungkin berisi gambar elektronik yang dapat terganggu dengan penolakan cookie tersebut.
            </Typography>
            <br />

            <Typography variant="h4">7. Tujuan Pengolahan Data Pribadi</Typography>
            <br />
            <Typography>
              Kami dapat menggunakan Data Pribadi untuk tujuan berikut:
            </Typography>
            <br />
            <ul>
              <li>
                <Typography>a. Untuk mengoperasikan dan memelihara Layanan Kami, termasuk memantau penggunaannya, administrasi sistem, statistik, dan tujuan pemecahan masalah.</Typography>
              </li>
              <li>
                <Typography>b. Untuk pelaksanaan perjanjian: pembuatan, kepatuhan, dan pelaksanaan pembelian untuk produk, barang, atau layanan yang dapat Anda tukarkan atau beli melalui Layanan atau perjanjian lain dengan Kami, sesuai kondisinya.</Typography>
              </li>
              <li>
                <Typography>c. Untuk menghubungi Anda: Untuk menghubungi Anda melalui e-mail, panggilan telepon, SMS, atau metode komunikasi elektronik lain yang setara, seperti pemberitahuan dari ponsel Anda, mengenai pembaruan atau komunikasi informatif yang berkaitan dengan fungsi, produk, atau layanan lain, termasuk pembaruan keamanan, sebagaimana diperlukan atau wajar untuk implementasinya.</Typography>
              </li>
              <li>
                <Typography>d. Untuk memberi Anda berita, penawaran khusus, dan informasi umum tentang barang, layanan, dan acara lain yang dapat ditawarkan yang serupa, kecuali Anda memilih untuk tidak menerima informasi tersebut.</Typography>
              </li>
              <li>
                <Typography>e. Untuk mengirimkan survei kepuasan mengenai layanan yang Kami berikan untuk meningkatkan layanan Kami kepada Anda.</Typography>
              </li>
              <li>
                <Typography>f. Untuk membantu Anda mengelola permintaan: Untuk menanggapi dan mengelola pertanyaan Anda kepada Kami.</Typography>
              </li>
              <li>
                <Typography>g. Untuk transfer bisnis: Kami dapat menggunakan Data Pribadi Anda dalam hal terjadi suatu evaluasi atau melakukan merger, divestasi, akuisisi, restrukturisasi, reorganisasi, pembubaran, atau penjualan atau transfer beberapa atau semua aset Kami, baik sebagai operasional atau sebagai bagian dari aset, dimana Data Pribadi tentang pengguna Layanan Kami adalah salah satu aset yang ditransfer.</Typography>
              </li>
              <li>
                <Typography>h. Kami dapat menggunakan Data Pribadi Anda untuk tujuan tambahan, seperti analisis data, mengidentifikasi tren penggunaan, menentukan efektivitas kampanye promosi Kami, dan mengevaluasi serta meningkatkan layanan, produk, layanan, pemasaran, dan pengalaman Kami.</Typography>
              </li>
              <li>
                <Typography>i. Kami dapat menggunakan Data Pribadi Anda untuk menyesuaikan pengalaman Anda di Layanan kami, seperti menampilkan konten yang menurut Kami mungkin Anda minati dan menampilkan konten yang sesuai dengan preferensi Anda.</Typography>
              </li>
            </ul>
            <br />
            <Typography>
              Kami dapat membagikan Data Pribadi Anda dalam situasi berikut:
            </Typography>
            <br />
            <ul>
              <li>
                <Typography>a. Kepada prosesor Data Pribadi Kami: Kami dapat membagikan Data Pribadi Anda dengan prosesor Data Pribadi untuk memantau dan menganalisis bagaimana layanan kami digunakan, dan untuk menghubungi Anda.</Typography>
              </li>
              <li>
                <Typography>b. Dengan Afiliasi: Jika kami membagikan Data Pribadi Anda dengan afiliasi Kami, Kami akan meminta mereka untuk mematuhi Kebijakan Privasi ini. Afiliasi didefinisikan sebagai perusahaan induk Kami dan setiap anak perusahaan, mitra usaha patungan, atau bisnis lain yang Kami kendalikan atau dikendalikan oleh Kami.</Typography>
              </li>
              <li>
                <Typography>c. Dengan mitra bisnis: Kami dapat membagikan informasi Anda dengan mitra bisnis Kami untuk menawarkan produk, layanan, atau promosi tertentu kepada Anda, Kami akan meminta mereka untuk mematuhi Kebijakan Privasi ini.</Typography>
              </li>
              <li>
                <Typography>d. Dengan pengguna lain: Saat Anda berbagi Data Pribadi atau berinteraksi dengan pengguna lain, informasi tersebut dapat dilihat oleh semua pengguna dan dapat didistribusikan secara publik.</Typography>
              </li>
              <li>
                <Typography>e. Untuk Penegakan Hukum: Kami dapat membagikan Data Pribadi Anda dengan Penegak Hukum bila perlu untuk mengungkapkan Data Pribadi tersebut.</Typography>
              </li>
              <li>
                <Typography>f. Dengan persetujuan Anda: Dengan persetujuan Anda, kami dapat mengungkapkan informasi pribadi Anda untuk tujuan lain.</Typography>
              </li>
            </ul>
            <br />

            <Typography variant="h4">8. Dasar Pemrosesan Data</Typography>
            <br />
            <Typography>
              Kami mengumpulkan dan memproses Data Pribadi Anda semata-mata berdasarkan persetujuan yang sah dari Anda, serta sesuai dengan dasar pemrosesan Data Pribadi lain sesuai dengan ketentuan peraturan perundang-undangan yang berlaku di Negara Republik Indonesia, termasuk namun tidak terbatas pada UU PDP.
            </Typography>
            <br />

            <Typography variant="h4">9. Hak-Hak Subjek Data Pribadi</Typography>
            <br />
            <Typography>
              Jika Anda telah menyatakan persetujuan Anda untuk aktivitas pemrosesan Data Pribadi apa pun, Anda dapat menarik persetujuan ini kapan saja dengan efek di masa mendatang. Penarikan tersebut tidak akan memengaruhi keabsahan pemrosesan sebelum penarikan persetujuan. Berdasarkan peraturan perundang-undangan yang berlaku di Negara Republik Indonesia, Anda berhak untuk:
            </Typography>
            <br />
            <ul>
              <li><Typography>- meminta akses ke Data Pribadi Anda;</Typography></li>
              <li><Typography>- meminta perbaikan Data Pribadi Anda;</Typography></li>
              <li><Typography>- meminta Salinan Data Pribadi Anda;</Typography></li>
              <li><Typography>- meminta penghapusan Data Pribadi Anda;</Typography></li>
              <li><Typography>- menarik persetujuan Data Pribadi Anda;</Typography></li>
              <li><Typography>- memberi keluhan atas Data Pribadi Anda; dan</Typography></li>
              <li><Typography>- meminta pembatasan Data Pribadi Anda.</Typography></li>
            </ul>
            <br />
            <Typography>
              Harap dicatat bahwa hak-hak yang disebutkan di atas mungkin dibatasi sesuai dengan ketentuan peraturan perundang-undangan yang berlaku di Negara Republik Indonesia.
            </Typography>
            <br />

            <Typography variant="h4">10. Penyimpanan dan Retensi Data</Typography>
            <br />
            <Typography>
              Data Pribadi Anda disimpan oleh Kami dan/atau penyedia layanan Kami, secara ketat sejauh yang diperlukan untuk pelaksanaan kewajiban Kami dan secara ketat selama waktu yang diperlukan untuk mencapai tujuan pengumpulan Data Pribadi, sesuai dengan undang-undang perlindungan data yang berlaku.
            </Typography>
            <br />
            <Typography>
              Setelah Anda mengakhiri akun Anda, Data Pribadi Anda tidak akan disimpan. Kami akan menghapusnya dari sistem dan catatan kami dalam waktu 10 (sepuluh) tahun sejak pendaftaran Anda, atau ketika Anda menggunakan hak Anda untuk dilupakan, atau ketika kami menganonimkannya dengan benar sehingga Anda tidak dapat diidentifikasi. Namun, jika kami diwajibkan oleh hukum atau peraturan yang berlaku, seperti persyaratan penyimpanan untuk Data Pribadi terkait perjanjian, komunikasi, atau bisnis, kami mungkin perlu menyimpan informasi Anda hingga 10 (sepuluh) tahun.
            </Typography>
            <br />

            <Typography variant="h4">11. Transfer Data Pribadi</Typography>
            <br />
            <Typography>
              Pengendali dan/atau Prosesor Data Pribadi Anda mungkin dapat berlokasi di luar wilayah Negara Republik Indonesia. Setelah Data Pribadi Anda ditransfer ke luar negeri (apabila dilakukan), Kami akan memberi tahu Anda secara terpisah sejauh yang diperlukan berdasarkan hukum dan peraturan perundang-undangan yang berlaku. Berkenaan dengan transfer data ke penerima tersebut di luar wilayah Negara Republik Indonesia, kami akan memberikan perlindungan terhadap Data Pribadi Anda yang sesuai, khususnya, dengan cara menandatangani perjanjian transfer data atau mengambil langkah-langkah lain untuk memberikan tingkat perlindungan data yang memadai (sesuai dengan pelaksanaannya).
            </Typography>
            <br />
            <Typography>
              Kami akan mematuhi semua prosedur yang diatur oleh peraturan perundang-undangan yang berlaku dan implementasinya.
            </Typography>
            <br />

            <Typography variant="h4">12. Pihak Ketiga & Pemrosesan Data</Typography>
            <br />
            <Typography>
              Layanan Kami dapat memuat tautan ke situs web, aplikasi, atau platform pihak ketiga yang tidak dioperasikan oleh Kami. Jika Anda menekan atau menuju tautan tersebut, Anda akan diarahkan ke layanan pihak ketiga. Kami tidak memiliki kendali atas, serta tidak bertanggung jawab terhadap, konten, kebijakan privasi, maupun praktik yang diterapkan oleh pihak ketiga tersebut.
            </Typography>
            <br />
            <Typography>
              Beberapa tautan mungkin menuju ke layanan yang dimiliki atau dioperasikan oleh penyedia pihak ketiga, termasuk yang memiliki afiliasi dengan Kami. Setiap situs web, aplikasi, atau platform pihak ketiga memiliki kebijakan privasi dan praktik keamanan masing-masing, yang sepenuhnya menjadi tanggung jawab pemilik atau pengelolanya. Oleh karena itu, Kami menyarankan Anda untuk membaca dan memahami kebijakan privasi dari setiap situs web, aplikasi, atau platform pihak ketiga yang Anda kunjungi.
            </Typography>
            <br />

            <Typography variant="h4">13. Perubahan Kebijakan Privasi</Typography>
            <br />
            <Typography>
              Kami dapat memperbarui Kebijakan Privasi ini berdasarkan kebijakan Kami dari waktu ke waktu untuk mencerminkan perubahan dalam praktik pemrosesan Data Pribadi Kami atau untuk memenuhi persyaratan hukum. Kami akan mempublikasikan perubahan tersebut pada halaman ini dan, jika diperlukan, memberi tahu Anda melalui e-mail atau melalui pemberitahuan di Layanan Kami.
            </Typography>
            <br />

            <Typography variant="h4">14. Data Pribadi Anak dan Penyandang Disabilitas</Typography>
            <br />
            <Typography>
              Layanan kami dapat ditujukan dan digunakan untuk anak-anak di bawah usia 18 (delapan belas) tahun. Kami tidak mengumpulkan informasi Data Pribadi dari anak-anak di bawah usia 18 (delapan belas) tahun tanpa persetujuan orang tua mereka. Jika Anda adalah orang tua atau wali dan Anda yakin anak Anda mungkin telah memberikan Data Pribadi kepada kami, silakan hubungi Kami.
            </Typography>
            <br />
            <Typography>
              Kami dapat mengumpulkan dan menggunakan Data Pribadi Anda dengan persetujuan orang tua Anda. Jika kami mengetahui bahwa kami telah mengumpulkan Data Pribadi dari siapa pun yang berusia di bawah 18 (delapan belas) tahun tanpa memperoleh persetujuan orang tua, Kami akan segera mengambil langkah-langkah untuk menghapus informasi tersebut dari tempat Data Pribadi tersebut disimpan.
            </Typography>
            <br />
            <Typography>
              Untuk penyandang disabilitas, Kami akan mengumpulkan Data Pribadi dengan terlebih dahulu mendapatkan persetujuan Anda dan/atau melalui wali Anda dan dengan mekanisme sesuai dengan ketentuan perundang-undangan yang berlaku.
            </Typography>

          </ItemGrid>
        </Grid>
      </BaseGrid>
      <Footer />
    </Box>
  );
}